module.exports = __webpack_public_path__ + "img/GoalSport_Logo_Final.43c388ab.svg";